export enum SignInFormField {
  email = 'email',
  password = 'password',
}

export type SignInFormValues = {
  [SignInFormField.email]: string;
  [SignInFormField.password]: string;
};

export enum VerificationCodeFormField {
  verificationCode = 'verificationCode',
}

export type VerificationCodeFormValues = {
  [VerificationCodeFormField.verificationCode]: string;
};
